import { defineComponent as _defineComponent } from 'vue'
import { ref, inject, watch } from 'vue';
import {
  BaseText,
  ButtonContainer,
  ButtonSecondary,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { ModalCreateWallet } from './components/ModalCreateWallet';
import { ProductCard } from './components/ProductCard';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  IProductRemove,
  IProductsRemoveParam
} from '@/modules/wallet-builder/src/services/types/models/IBffInvestments';
import { IProductGetLastState } from '@/modules/catalog/services/products-acquisition';

interface Props {
  products: IProductGetLastState[];
  isDeleteActive: boolean;
  portfolioId?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectedProductList',
  props: {
    products: null,
    isDeleteActive: { type: Boolean },
    portfolioId: null
  },
  emits: ['show-wallet-selection', 'disable-delete-mode'],
  setup(__props: any, { emit }) {

const props = __props as {
  products: IProductGetLastState[];
  isDeleteActive: boolean;
  portfolioId?: string;
}




const removeProductFromWallet = inject(
  'removeProductFromWallet',
  async (params: IProductsRemoveParam) => ({ params })
);

watch(
  () => props.products,
  (newValue, _) => {
    if (newValue.length === 0) {
      emit('show-wallet-selection');
    }
  }
);

watch(
  () => props.isDeleteActive,
  (newValue, _) => {
    if (!newValue) {
      productSelected.value = [];
    }
  }
);

const productSelected = ref<string[]>([]);

const showWalletModal = ref(false);

const isLoading = ref(false);

const isLoadingRemove = ref(false);

function handleConfirmationEvent() {
  showWalletModal.value = !showWalletModal.value;
}

function handleInstrumentSelected({ id }: IProductRemove) {
  if (props.isDeleteActive) {
    if (productSelected.value.includes(id)) {
      productSelected.value = productSelected.value.filter(item => item !== id);
    } else {
      productSelected.value.push(id);
    }
  }
}

async function handleDeleteProduct() {
  try {
    isLoadingRemove.value = true;
    await removeProductFromWallet({ productIds: productSelected.value });
  } finally {
    emit('disable-delete-mode');
    isLoadingRemove.value = false;
  }
}

return { __sfc: true,props, emit, removeProductFromWallet, productSelected, showWalletModal, isLoading, isLoadingRemove, handleConfirmationEvent, handleInstrumentSelected, handleDeleteProduct, BaseText, ButtonContainer, ButtonSecondary, ButtonPrimary, ModalCreateWallet, ProductCard, NebraskaColors }
}

})